import React from 'react';

export default () => (
  <svg width="37" height="32" viewBox="-1 -1 39 34" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#21304A">
        <g>
          <path d="M3.917 2H1a1 1 0 1 1 0-2h8.062a1 1 0 0 1 0 2H5.917v8.726a1 1 0 1 1-2 0V2zm10.112-2a1 1 0 0 0 0 2h21.955a1 1 0 0 0 0-2H14.029zm-.002 6a1 1 0 0 0 0 2h21.957a1 1 0 0 0 0-2H14.027zm0 6a1 1 0 0 0 0 2h21.957a1 1 0 0 0 0-2H14.027zM1.025 18a1 1 0 0 0 0 2h34.958a1 1 0 1 0 0-2H1.025zm0 6a1 1 0 0 0 0 2h34.956a1 1 0 1 0 0-2H1.025zm0 6a1 1 0 0 0 0 2h34.958a1 1 0 1 0 0-2H1.025z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-longtext.es6.js